import { SyntheticEvent } from 'react'
import mixpanel from 'mixpanel-browser'

import { CloseDocType, Language, PaymentMethod, ProfileType } from '../store/user/types'

import { isInStorage } from '@/utils/localStorage'
const isAnalyticsOff = isInStorage('isImpersonate')

interface IMixpanelProps {
  $email?: string
  Industry?: number | null
  'Paying Customer'?: 'Yes' | 'No'
  'Client ID'?: number | null
  Optimizer?: 'Yes' | 'No'
  'Facebook AdAccounts'?: number
  'TikTok AdAccounts'?: number
  'Archived AdAccounts'?: number
  $name?: string
  Audiences?: 'Yes' | 'No'
  Language?: Language
  CloseDocType?: CloseDocType
  PaymentMethod?: PaymentMethod
  ProfileType?: ProfileType
  Country?: string
}

let isMixpanelLoaded = false

if (mixpanel) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '', {
    loaded: () => {
      isMixpanelLoaded = true
    },
  })
}

const isProduction = process.env.NODE_ENV === 'production' && process.env.REACT_APP_MIXPANEL_TOKEN

const actions = {
  alias: (id: string) => {
    if (isProduction && isMixpanelLoaded) {
      mixpanel.alias(id.toLowerCase())
    }
  },
  identify: (id: string) => {
    if (isProduction && isMixpanelLoaded) {
      mixpanel.identify(id.toLowerCase())
    }
  },
  reset: () => {
    if (isProduction && isMixpanelLoaded) {
      mixpanel.reset()
    }
  },
  set: (props: IMixpanelProps) => {
    if (isProduction && isMixpanelLoaded) {
      mixpanel.people.set(props)
    }
  },
  track: (name: string, props?: any) => {
    if (isProduction && isMixpanelLoaded) {
      mixpanel.track(name, props)
    }
  },
}

export const sendMixpanelEvent = (eventName: string, props?: { [key: string]: string }) => {
  if (isAnalyticsOff) {
    return
  }

  if (props) {
    actions.track(eventName, props)
  } else {
    actions.track(eventName)
  }
}

export const onSendMixpanelEvent = (eventName: string, props?: { [key: string]: string }) => {
  return (event?: SyntheticEvent) => {
    event?.stopPropagation()

    sendMixpanelEvent(eventName, props)
  }
}

export const Mixpanel = actions
